import * as Types from '../../graphql/types'

import { gql } from 'apollo-boost'
import * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from '@apollo/react-hooks'
const defaultOptions = {}
export type DeleteMessageAsLawyerMutationVariables = Types.Exact<{
  messageId: Types.Scalars['Int']
}>

export type DeleteMessageAsLawyerMutation = { __typename?: 'Mutation'; deleteLawyerMessage: number }

export const DeleteMessageAsLawyerDocument = gql`
  mutation DeleteMessageAsLawyer($messageId: Int!) {
    deleteLawyerMessage(messageId: $messageId)
  }
`
export type DeleteMessageAsLawyerMutationFn = ApolloReactCommon.MutationFunction<
  DeleteMessageAsLawyerMutation,
  DeleteMessageAsLawyerMutationVariables
>
export function useDeleteMessageAsLawyerMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteMessageAsLawyerMutation,
    DeleteMessageAsLawyerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    DeleteMessageAsLawyerMutation,
    DeleteMessageAsLawyerMutationVariables
  >(DeleteMessageAsLawyerDocument, options)
}
export type DeleteMessageAsLawyerMutationHookResult = ReturnType<
  typeof useDeleteMessageAsLawyerMutation
>
export type DeleteMessageAsLawyerMutationResult =
  ApolloReactCommon.MutationResult<DeleteMessageAsLawyerMutation>
export type DeleteMessageAsLawyerMutationOptions = ApolloReactCommon.BaseMutationOptions<
  DeleteMessageAsLawyerMutation,
  DeleteMessageAsLawyerMutationVariables
>
